<template>
  <div id="excludedExpenses">
    <v-layout>
      <page-title :heading=heading :subheading=subheading :icon=icon class="mr-5">
      </page-title>
      <h2 class="ml-5 mt-4 subtitle-1">{{$t('conciliation.period')}}: {{dateFormat(startDate)}} - {{dateFormat(endDate)}}</h2>
    </v-layout>
    <v-container class="py-0 my-0">
      <v-flex class="text-xs-right py-0 my-0">
        <v-btn
          color="primary"
          round
          outline
          :loading="downloadLoading"
          @click="downloadXls()"
        >
          {{$t('conciliation.download')}}
          <v-icon right>cloud_download</v-icon>
        </v-btn>
      </v-flex>
      <v-flex class="text-xs-right py-0 my-0">
        <v-dialog
          persistent
          v-model="dialogFilter"
          max-width="700px"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              color="primary"
              round
              outline
              v-on="on"
            >
              <v-icon left>filter_list</v-icon>
              {{$t('general.filter')}}
            </v-btn>
          </template>
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">{{$t('general.filter')}}</h2>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-form
                lazy-validation
                ref="form"
                v-model="valid"
                >
                  <v-layout>
                    <v-flex xs6>
                      <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            required
                            :rules="rules.required"
                            :error-messages="errors.startDate"
                            v-model="startDate"
                            :label="$t('general.startDate')"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          :max="endDate"
                          color="primary"
                          v-model="startDate"
                          @input="menu = false"
                          :locale="$t('history.local')"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs6>
                      <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            required
                            :rules="rules.required"
                            v-model="endDate"
                            :error-messages="errors.endDate"
                            :label="$t('general.endDate')"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          color="primary"
                          v-model="endDate"
                          @input="menu2 = false"
                          :max="new Date().toISOString().substr(0, 10)"
                          :min="startDate"
                          :locale="$t('history.local')"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex>
                      <v-switch
                        color="primary"
                        v-model="switchAllEmployees"
                        :label="switchAllEmployees
                          ? $t('expenseDetailEmployee.allEmployees')
                          : $t('expenseDetailEmployee.perEmployee')"
                      ></v-switch>
                      <v-autocomplete
                        v-if="!switchAllEmployees"
                        v-model="selectedEmployee"
                        item-text="name"
                        item-value="id"
                        persistent-hint
                        :rules="rules.required"
                        :items="employees"
                        :label="$t('expenseDetailEmployee.employee')"
                      >
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                      <v-flex xs8>
                        <v-select
                          :items="excludedTypes"
                          v-model="excludedType"
                          :label="$t('conciliation.excludeBy')"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary darken-1"
                round
                flat
                @click="close"
              >
                {{$t('general.close')}}
              </v-btn>
              <v-btn
                :loading="loading"
                :disabled="loading"
                color="primary"
                round
                depressed
                @click="send"
              >
                {{$t('general.submit')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <b-row>
        <!-- Monto TC -->
        <b-col class="px-2" col-md-6 col-xl-4>
          <b-card class="pa-0 widget-content yellow-block">
            <div class="">
              <div>
                <div class="widget-heading text-center">{{$t('conciliation.tCAmount')}}:</div>
                <div class="text-center" v-if="loading">
                  <v-progress-circular indeterminate size="20"></v-progress-circular>
                </div>
                <div class="widget-data-filter " v-else>
                  <h2><b>{{ allAmount | formatCurrency }}</b></h2>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <!-- Monto conciliado Bluespend -->
        <b-col class="px-2" col-md-6 col-xl-4>
          <b-card class="pa-0 widget-content green-block">
            <div class="">
              <div>
                <div class="widget-heading text-center">{{$t('conciliation.bluespendReconciledAmount')}}:</div>
                <div class="text-center" v-if="loading">
                  <v-progress-circular indeterminate size="20"></v-progress-circular>
                </div>
                <div class="widget-data-filter " v-else>
                  <h2><b>{{ consiliateAmount | formatCurrency }}</b></h2>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <!-- Monto Faltante -->
        <b-col class="px-2" col-md-6 col-xl-4>
          <b-card class="pa-0 widget-content red-block">
            <div class="">
              <div>
                <div class="widget-heading text-center">{{$t('conciliation.missingAmount')}}:</div>
                <div class="text-center" v-if="loading">
                  <v-progress-circular indeterminate size="20"></v-progress-circular>
                </div>
                <div class="widget-data-filter " v-else>
                  <h2><b>{{ missingAmount | formatCurrency }}</b></h2>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <!-- Monto Excluidos -->
        <b-col class="px-2" col-md-6 col-xl-4>
          <b-card class="pa-0 widget-content blue-block">
            <div class="">
              <div>
                <div class="widget-heading text-center">{{$t('conciliation.excludedAmount')}}:</div>
                <div class="text-center" v-if="loading">
                  <v-progress-circular indeterminate size="20"></v-progress-circular>
                </div>
                <div class="widget-data-filter " v-else>
                  <h2><b>{{ excludedAmount | formatCurrency }}</b></h2>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <!-- Filtro Empleados -->
        <b-col class="px-2" col-md-12 col-xl-12 v-if="userLogged.roles && userLogged.roles[0].name === 'ADMIN' && selectedEmployee">
          <b-card class="ma-0 pa-0 widget-content bg-info">
            <div class="text-white ma-0 pa-0">
              <div class="ma-0 pa-0">
                <div class="text-white text-center" v-if="!selectedEmployee">
                  <v-progress-circular indeterminate size="20"></v-progress-circular>
                </div>
                <div class="text-white ma-0 pa-0" v-else>
                  <v-autocomplete
                    v-model="selectedEmployee"
                    item-text="name"
                    item-value="id"
                    :rules="rules.required"
                    :items="employees"
                    class="select-employee"
                    @change="selectedEmployeeChange()"
                  >
                    <template #selection="{ item }">
                      <span class="select-employee text-white text-truncate">{{item.name}}</span>
                    </template>
                  </v-autocomplete>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <v-spacer class="my-3"></v-spacer>
      <template variant="primary" v-slot:title>
        <h5 class="my-0">{{$t('conciliation.status.excluded')}}</h5>
      </template>
      <v-flex>
        <v-toolbar flat color="bg-sidebar" dark>
          <h2 class="my-0">{{$t('conciliation.status.excluded')}} {{excludedType}}</h2>
          <v-spacer></v-spacer>
          <v-text-field
            color="light"
            v-model="search"
            :label="$t('general.search')"
            clearable
            append-outer-icon="search">
          </v-text-field>
        </v-toolbar>
        <v-data-table
          :search="search"
          class="elevation-2"
          :headers="headersByUser"
          :items="conciliations"
          :loading="loadTable"
          :rows-per-page-items="[10,15,25]"
          :pagination.sync="pagination">
          <template v-slot:headers="props">
            <tr class="bg-heavy-rain">
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                @click="changeSort(header)"
                >
                <h2 class="font-weight-black primary--text mb-0">
                  <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                  {{ header.text }}
                </h2>
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr v-if="excludedType === 'AMEX'" class="">
              <td width="60px">{{props.item.id}}</td>
              <td class="text-sm-center">{{props.item.user ? props.item.user.name : '- -'}}</td>
              <td class="text-sm-center">{{props.item.consiliate_date}}</td>
              <td class="text-sm-center">{{props.item.user ? props.item.user.card_number : '- -'}}</td>
              <td class="text-sm-center">{{props.item.transaction_number}}</td>
              <td class="text-sm-center">{{props.item.supplier_name}}</td>
              <td class="text-sm-left">{{props.item.description}}</td>
              <td class="text-sm-left">{{props.item.amount | formatCurrency}}</td>
              <td class="text-sm-center">
                <v-tooltip bottom v-if="userLogged.roles && userLogged.roles[0].name === 'EMPLOYEE'">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      small
                      outline
                      icon
                      color="info"
                      v-on="on"
                      @click="addFiscal(props.item)"
                      >
                      <v-icon small>add</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('expenses.addFiscalExpense') }}</span>
                </v-tooltip>
                <v-tooltip bottom v-if="userLogged.roles && userLogged.roles[0].name === 'EMPLOYEE'">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      small
                      outline
                      icon
                      color="info"
                      v-on="on"
                      @click="addNoFiscal(props.item)"
                      >
                      <v-icon small>add</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('expenses.addNoFiscalExpense') }}</span>
                </v-tooltip>
                <v-tooltip bottom v-if="userLogged.roles && userLogged.roles[0].name === 'EMPLOYEE'">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      small
                      outline
                      icon
                      color="info"
                      v-on="on"
                      @click="addNoFiscal(props.item)"
                      >
                      <v-icon small>add</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('expenses.addNoFiscalExpense') }}</span>
                </v-tooltip>
                <v-tooltip bottom v-if="userLogged.roles && userLogged.roles[0].name === 'ADMIN'">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      small
                      outline
                      icon
                      color="info"
                      v-on="on"
                      @click="resetConfirm(props.item)"
                      >
                      <v-icon small>fa fa-undo-alt</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('expenses.resetToReconcile') }}</span>
                </v-tooltip>
              </td>
            </tr>
            <tr v-else-if="excludedType === 'BLUESPEND'" class="">
              <td width="60px">{{props.item.id}}</td>
              <td class="text-sm-center">{{props.item.gst_expenses ? props.item.gst_expenses.user.name : '- -'}}</td>
              <td class="text-sm-center">{{props.item.date}}</td>
              <td class="text-sm-center">{{props.item.issuer_name}}</td>
              <td class="text-sm-left">{{props.item.description}}</td>
              <td class="text-sm-left">{{props.item.folio}}</td>
              <td class="text-sm-left">{{props.item.total_mxn | formatCurrency}}</td>
              <td class="text-sm-left">
                <v-btn
                  small
                  outline
                  round
                  color="primary"
                  icon
                  @click="viewExpenses(props.item)"
                >
                  <v-icon small>search</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:footer>
            <td colspan="8" class="text-xs-right">
              <span class="primary--text text-uppercase font-weight-black h5">{{$t('general.totalExpenses')}}:</span>
              <span class="primary--text text-uppercase font-weight-black h5">{{ sumaTotal | formatCurrency }} MXN</span>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-container>
    <v-dialog
      v-model="dialogItem"
      scrollable
      max-width="900px"
      persistent>
      <v-card>
        <v-toolbar flat>
          <h2 class="font-weight-black primary--text mb-0">{{$t('workflowValidation.item' )}}{{ editedItem.id }} <span> ( {{editedItem.gst_receipt_types_id === 1 ? 'Fiscal' : 'No Fiscal'}} )</span></h2>
        </v-toolbar>
        <template v-if="editedItem.gst_receipt_types_id === 1">
          <v-card-text class="text-center" v-if="!cfdiHtml">
            <v-progress-circular class="my-5" indeterminate size="70" color="primary" />
          </v-card-text>
          <v-card-text v-else>
            <iframe
              name="cfdi"
              :srcdoc="cfdiHtml"
              style="width:845px; height:1200px; border:0">
            </iframe>
            <v-container grid-list-md>
              <v-layout wrap>
                  <v-flex xs12 md6>
                    <v-text-field
                      :label="$t('general.category')"
                      disabled
                      outline
                      :value="editedItem.gst_categories ? editedItem.gst_categories.name : ''">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      :label="$t('general.comment')"
                      disabled
                      outline
                      v-model="editedItem.comment">
                    </v-textarea>
                  </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </template>
        <template v-if="editedItem.gst_receipt_types_id === 2">
          <v-card-text class="text-center" v-if="loadItem">
            <v-progress-circular class="my-5" indeterminate size="70" color="primary" />
          </v-card-text>
          <v-card-text v-else>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex layout row wrap v-bind:class="{'xs6': dataURL}">
                  <v-flex xs6>
                    <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.date')}}</strong></p>
                    <p class="text-sm-left">{{editedItem.date}}</p>
                  </v-flex>
                  <v-flex xs6>
                    <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.category')}}</strong></p>
                    <p class="text-sm-left">{{editedItem.gst_categories ? editedItem.gst_categories.name : ''}}</p>
                  </v-flex>
                  <v-flex xs6>
                    <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.country')}}</strong></p>
                    <p class="text-sm-justify">{{editedItem.country && editedItem.country.descripcion}}</p>
                  </v-flex>
                  <v-flex xs12>
                    <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.description')}}</strong></p>
                    <p class="text-sm-left">{{editedItem.description && editedItem.description}}</p>
                  </v-flex>
                  <v-flex xs6>
                    <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.currency')}}</strong></p>
                    <p class="text-sm-left">{{editedItem.currency && editedItem.currency.c_Moneda}} - {{editedItem.currency && editedItem.currency.descripcion}}</p>
                  </v-flex>
                  <v-flex xs6>
                    <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.exchangeRate')}}</strong></p>
                    <p class="text-sm-left">{{editedItem.exchange}}</p>
                  </v-flex>
                  <v-flex xs6>
                    <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.subtotal')}}</strong></p>
                    <p class="text-sm-left">${{editedItem.subtotal}} {{editedItem.currency.c_Moneda}}</p>
                  </v-flex>
                  <v-flex xs6>
                    <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.total')}}</strong></p>
                    <p class="text-sm-left">${{editedItem.total}} {{editedItem.currency.c_Moneda}}</p>
                  </v-flex>
                  <v-flex xs6>
                    <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.formaPago')}}</strong></p>
                    <p class="text-sm-left">{{editedItem.sat_forma_pago && editedItem.sat_forma_pago.descripcion}}</p>
                  </v-flex>
                  <v-flex xs6>
                    <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.folioRef')}}</strong></p>
                    <p class="text-sm-left">{{editedItem.folio}}</p>
                  </v-flex>
                  <v-flex xs6>
                    <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.comment')}}</strong></p>
                    <p class="text-sm-justify">{{editedItem.comment}}</p>
                  </v-flex>
                </v-flex>
                <v-flex xs6 layout v-if="dataURL">
                  <v-flex xs12>
                    <a v-if="!isPDF(dataURL)" @click="openPDF()">
                      <zoom-on-hover :img-normal="dataURL"></zoom-on-hover>
                    </a>
                    <v-btn block v-if="isPDF(dataURL)" @click="openPDF()" color="primary" depressed>
                      <v-icon left>insert_drive_file</v-icon> {{$t('expenseItems.watchFile')}}
                    </v-btn>
                    <iframe v-if="isPDF(dataURL)" :src="dataURL" frameborder="0" width="100%" height="400px"></iframe>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </template>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            flat
            round
            class="white--text"
            depressed
            @click="close">
            {{$t('general.cancel')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- modal para agregar gasto en conciliaciones -->
    <v-dialog
        persistent
        v-model="addExpenseDialog"
        max-width="700px"
      >
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">{{$t('expenseItems.add')}}</h2>
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-form
              lazy-validation
              ref="form"
              v-model="valid"
              >
                <v-layout>
                  <v-flex xs6>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              round
              flat
              @click="close"
            >
              {{$t('general.close')}}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="primary"
              round
              depressed
            >
              {{$t('general.submit')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <!-- fin modal agregar gasto en conciliaciones -->
    <v-dialog
    v-model="dialogXML"
    max-width="700px"
    scrollable
    persistent>
    <v-card>
      <v-toolbar flat>
        <h2 class="font-weight-black primary--text mb-0">CFDI (XML)</h2>
      </v-toolbar>
      <v-card-text>
        <v-form ref="formXML" lazy-validation>
          <v-container v-if="selectXml">
            <v-layout>
              <v-flex xs-12>
                <vue-dropzone
                  ref="dropzoneXML"
                  id="dropzoneXML"
                  :options="dropzoneOptionsXML"
                  v-on:vdropzone-added="fileAddedXml"
                  v-on:vdropzone-error="fileUploadError"
                  v-on:vdropzone-success="xmlUpload"
                  v-on:vdropzone-queue-complete="xmlQueueComplete">
                </vue-dropzone>
                <v-progress-linear v-if="loadingFile" :indeterminate="loadingFile"></v-progress-linear>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container v-if="uploadedXML && uploadIndex > -1 && !readXml">
            <v-layout row wrap>
              <p>{{ $t('expenseItems.readItemProgress', { current: uploadIndex + 1, total: uploadedXML.length }) }}</p>
            </v-layout>
          </v-container>
          <v-container v-if="readXml">
            <v-layout row wrap>
              <v-flex class="d-flex" xs12>
                <v-text-field
                  style="width: 80%"
                  v-model="editedItemExpense.emisor"
                  :label="'Emisor'"
                  :error-messages="errors.uuid"
                  readonly/>
                  <v-tooltip right>
                    <template v-slot:activator="{ on }">
                      <v-icon color="primary" v-on="on">verified</v-icon>
                    </template>
                    <span>{{$t('expenseItems.verifyEFOMsg')}}</span>
                  </v-tooltip>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="editedItemExpense.uuid"
                  :label="$t('general.uuid')"
                  :error-messages="errors.uuid"
                  readonly></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editedItemExpense.date"
                  :label="$t('general.date')"
                  :error-messages="errors.date"
                  prepend-icon="event"
                  readonly></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete
                  v-model="editedItemExpense.gst_categories_id"
                  :label="$t('general.category')"
                  :items="categories"
                  item-text="name"
                  item-value="id"
                  :error-messages="errors.gst_categories_id"
                  :rules="rules.required">
                    <template slot="selection" slot-scope="data">
                      {{data.item.name}}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{data.item.name}}
                    </template>
                  </v-autocomplete>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editedItemExpense.country.descripcion"
                  :error-messages="errors.country"
                  :label="$t('general.country')"
                  readonly></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="editedItemExpense.description"
                  :error-messages="errors.description"
                  :label="$t('general.description')"
                  readonly></v-textarea>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editedItemExpense.currency.descripcion"
                  :error-messages="errors.currency"
                  :label="$t('general.currency')"
                  readonly></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editedItemExpense.exchange"
                  :label="$t('general.exchangeRate')"
                  :error-messages="errors.exchange"
                  :rules="rules.required && rules.decimal && rules.exchange"></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editedItemExpense.subtotal"
                  :label="$t('general.subtotal')"
                  :error-messages="errors.subtotal"
                  readonly></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  v-model="editedItemExpense.discount"
                  :label="$t('general.discount')"
                  :error-messages="errors.discount"
                  readonly></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  v-model="editedItemExpense.total"
                  :label="$t('general.total')"
                  :error-messages="errors.total"
                  readonly></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editedItemExpense.sat_forma_pago.descripcion"
                  :label="$t('general.formaPago')"
                  :error-messages="errors.sat_formaPago_id"
                  readonly></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editedItemExpense.sat_metodo_pago.descripcion"
                  :label="$t('general.metodoPago')"
                  :error-messages="errors.sat_metodoPago_id"
                  readonly></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editedItemExpense.folio"
                  :error-messages="errors.folio"
                  :label="$t('general.folioRef')"
                  readonly></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="editedItemExpense.comment"
                  :label="$t('general.comment')"
                  :error-messages="errors.comment"></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container>
            <v-flex xs12 v-if="editedItemExpense.gst_categories_id === 8">
              <v-checkbox
                v-model="editedItemExpense.hasTip"
                :error-messages="errors.hasTip"
                label="Desea agregar propina al gasto?"></v-checkbox>
            </v-flex>
            <v-flex xs6 v-if="editedItemExpense.hasTip && editedItemExpense.gst_categories_id === 8">
                <v-text-field
                  type="number"
                  v-model="editedItemTipExpense.amount"
                  :error-messages="errors.amount"
                  :label="$t('general.amount')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="editedItemExpense.hasTip && editedItemExpense.gst_categories_id === 8">
                <vue-dropzone
                  ref="dropzone2"
                  id="dropzone2"
                  :options="dropzoneOptions"
                  v-on:vdropzone-file-added="fileAdded"
                  v-on:vdropzone-error="fileUploadError"
                  v-on:vdropzone-success="fileUploadTip">
                </vue-dropzone>
              </v-flex>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          round
          color="primary darken-1"
          flat
          @click="closeDialogXML()">
          {{ $t('general.cancel') }}
        </v-btn>
        <v-btn
          round
          color="warning"
          flat
          @click="resetXML()">
          {{ $t('general.reset') }}
        </v-btn>
        <v-btn
          v-if="readXml"
          round
          color="primary"
          :loading="loading"
          :disabled="loading"
          @click="submitXML()">
          {{ submitXMLButton }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialog"
    max-width="700px"
    scrollable
    persistent>
    <v-card>
      <v-toolbar flat>
        <h2 class="font-weight-black primary--text mb-0">{{formTitle}}</h2>
      </v-toolbar>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-alert
              :value="error"
              color="error"
              icon="warning"
              outline
              transition="scale-transition">
              {{errorMessage}}
            </v-alert>
            <v-form
              ref="form"
              lazy-validation>
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12 md6>
                    <v-menu
                      v-model="datemenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="editedItemExpense.date"
                          :label="$t('general.date')"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                          :rules="rules.required"
                          :error-messages="errors.date"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        color="primary"
                        :locale="$t('general.locale')"
                        v-model="editedItemExpense.date"
                        @input="datemenu = false"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-autocomplete
                      v-model="editedItemExpense.gst_categories_id"
                      :label="$t('general.category')"
                      :items="categories"
                      item-text="name"
                      item-value="id"
                      :error-messages="errors.gst_categories_id"
                      :rules="rules.required">
                      <template slot="selection" slot-scope="data">
                        {{data.item.name}}
                      </template>
                      <template slot="item" slot-scope="data">
                        {{data.item.name}}
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <!-- <v-flex xs12 md6>
                    <v-checkbox
                      v-model="editedItem.is_refund"
                      :error-messages="errors.is_refund"
                      :label="$t('general.isRefund')">
                    </v-checkbox>
                  </v-flex> -->
                  <v-flex xs12 md6>
                    <v-autocomplete
                      v-model="editedItemExpense.country.id"
                      :error-messages="errors.country"
                      :label="$t('general.country')"
                      :items="items"
                      item-value="id"
                      item-text="descripcion"
                      :rules="rules.required"
                      :search-input.sync="search"
                      :filter="dataArrayFilter.filter"
                      cache-items
                      flat
                      hide-details
                      auto-select-first
                      clearable
                      >
                      <template slot="selection" slot-scope="data">
                        {{ data.item.c_Pais }} - {{ data.item.descripcion }}
                      </template>
                      <template slot="item" slot-scope="data">
                        {{ data.item.c_Pais }} - {{ data.item.descripcion }}
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      v-model="editedItemExpense.description"
                      :label="$t('general.description')"
                      :error-messages="errors.description"
                      :rules="rules.required">
                    </v-textarea>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-autocomplete
                      clearable
                      v-model="editedItemExpense.currency"
                      :label="$t('general.currency')"
                      :error-messages="errors.currency"
                      :items="satMoneda"
                      item-text="descripcion"
                      item-value="id"
                      :filter="currencyFilter"
                      :rules="rules.required"
                      return-object>
                      <template slot="selection" slot-scope="data">
                        {{ data.item.c_Moneda }} - {{ data.item.descripcion }}
                      </template>
                      <template slot="item" slot-scope="data">
                        {{ data.item.c_Moneda }} - {{ data.item.descripcion }}
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      :readonly="setMXN"
                      v-model="editedItemExpense.exchange"
                      :label="$t('general.exchangeRate')"
                      :error-messages="errors.exchange"
                      :rules="rules.required && rules.decimal && rules.exchange">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 md5>
                    <v-text-field
                      v-model="editedItemExpense.subtotal"
                      :label="$t('general.subtotal')"
                      :error-messages="errors.subtotal"
                      :rules="rules.required && rules.decimal"
                      @keyup="getTotal(1)">
                      <v-tooltip slot="append" bottom>
                        <v-icon slot="activator" color="grey" dark>mdi-help-circle</v-icon>
                        <span>{{$t('expenses.amountMessage')}}</span>
                      </v-tooltip>
                    </v-text-field>
                    <p class="caption">{{amountMXN(editedItemExpense.subtotal, editedItemExpense.exchange) > 0.00 ?
                    '$' + amountMXN(editedItemExpense.subtotal, editedItemExpense.exchange) + ' MXN' : ''}} </p>
                  </v-flex>
                  <v-flex xs1 md2></v-flex>
                  <v-flex xs12 md5>
                    <v-text-field
                      v-model="editedItemExpense.total"
                      :label="$t('general.total')"
                      :error-messages="errors.total"
                      :rules="rules.required && rules.decimal"
                      @keyup="getTotal(2)">
                      <v-tooltip slot="append" bottom>
                        <v-icon slot="activator" color="grey" dark>mdi-help-circle</v-icon>
                        <span>{{$t('expenses.amountMessage')}}</span>
                      </v-tooltip>
                    </v-text-field>
                    <p class="caption">{{amountMXN(editedItemExpense.total, editedItemExpense.exchange) > 0.00 ?
                    '$' + amountMXN(editedItemExpense.total, editedItemExpense.exchange) + ' MXN' : ''}} </p>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-autocomplete
                      v-model="editedItemExpense.sat_forma_pago"
                      :label="$t('general.formaPago')"
                      :items="satFormaPago"
                      item-text="descripcion"
                      item-value="id"
                      :rules="rules.required"
                      :error-messages="errors.sat_formaPago_id"
                      return-object>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItemExpense.folio"
                      :error-messages="errors.folio"
                      :label="$t('general.folioRef') + $t('general.optionalField')"
                      >
                    </v-text-field>
                  </v-flex>
                  <!-- <v-flex xs12 v-if="editedIndex > -1">
                    <label>{{$t('general.image')}}:</label>
                    <v-btn v-if="!isPDF(dataURL)" depressed color="primary" block @click="viewImg = !viewImg">
                      <v-icon left>{{viewImg === false ? 'visibility' : 'visibility_off'}}</v-icon>
                        {{ viewImg === false ? $t('workflowValidation.showImage') : $t('workflowValidation.hideImage')}}
                    </v-btn>
                    <v-btn block v-if="isPDF(dataURL)" @click="openPDF()" color="primary" depressed>
                      <v-icon left>insert_drive_file</v-icon> {{$t('expenseItems.watchFile')}}
                    </v-btn>
                    <div v-if="viewImg === true">
                      <a v-if="!isPDF(dataURL)" @click="openPDF()">
                        <zoom-on-hover :img-normal="dataURL"></zoom-on-hover>
                      </a>
                    </div>
                    <label>{{$t('workflowValidation.changeImage')}}</label>
                    <vue-dropzone
                      ref="dropzone"
                      id="dropzone"
                      :options="dropzoneOptions"
                      v-on:vdropzone-file-added="fileAdded"
                      v-on:vdropzone-error="fileUploadError"
                      v-on:vdropzone-success="fileUpload">
                    </vue-dropzone>
                  </v-flex> -->
                  <!-- <v-flex xs12>
                    <v-textarea
                      v-model="editedItemExpense.comment"
                      :label="$t('general.comment') + $t('general.optionalField')"
                      :error-messages="errors.comment">
                    </v-textarea>
                  </v-flex> -->
                  <v-flex xs12>
                    <vue-dropzone
                      ref="dropzone"
                      id="dropzone"
                      :options="dropzoneOptions"
                      v-on:vdropzone-file-added="fileAdded"
                      v-on:vdropzone-error="fileUploadError"
                      v-on:vdropzone-success="fileUpload">
                    </vue-dropzone>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          round
          flat
          color="primary darken-1"
          @click="closeDialog()">
          {{ $t('general.cancel') }}
        </v-btn>
        <v-btn
          round
          color="warning"
          flat
          @click="reset()">
          {{ $t('general.reset') }}
        </v-btn>
        <v-btn
          round
          color="primary"
          :loading="loading"
          :disabled="loading"
          @click="submit()">
          {{ $t('general.submit') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog persistent v-model="resetDialog" max-width="500px">
    <v-card>
      <v-toolbar flat>
        <h2 class="font-weight-black primary--text mb-0">
          {{ $t("expenses.confirmReset") }}
        </h2>
      </v-toolbar>
      <v-card-text class="text-sm-justify">
        {{ $t("expenses.resetQuestion")}}:
        <p><strong>{{ expenseAmex.description }} ({{expenseAmex.transaction_number}})</strong>
        {{ "?" }}
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary darken-1"
          round
          flat
          @click="close"
        >
          {{ $t("general.cancel") }}
        </v-btn>
        <v-btn
          :loading="loading"
          :disabled="loading"
          color="primary"
          round
          depressed
          @click="resetToReconcile()"
        >
          {{ $t("general.accept") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import {library} from '@fortawesome/fontawesome-svg-core'
import {
  faDonate,
  faUndoAlt
} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
library.add(
  faDonate,
  faUndoAlt
)
export default {
  name: 'EcludedExpenses',
  components: {
    vueDropzone: vue2Dropzone,
    'font-awesome-icon': FontAwesomeIcon
  },
  data () {
    return {
      resetDialog: false,
      expenseAmex: {
        id: 0,
        transaction_number: '',
        description: ''
      },
      defaultExpenseAmex: {
        id: 0,
        transaction_number: '',
        description: ''
      },
      totalAmounts: [],
      allAmount: 0,
      consiliateAmount: 0,
      excludedAmount: 0,
      missingAmount: 0,
      userLogged: {},
      expense_type: 'small_box',
      excludedType: 'AMEX',
      excludedTypes: [
        {
          id: 1,
          text: 'AMEX',
          value: 'AMEX'
        },
        {
          id: 2,
          text: 'BLUESPEND',
          value: 'BLUESPEND'
        }
      ],
      selectedEmployee: null,
      switchAllEmployees: true,
      employees: [],
      startDate: new Date().toISOString().substr(0, 8) + '01',
      endDate: new Date().toISOString().substr(0, 10),
      expenses_amex_id: null,
      errorMessage: '',
      uploadedXML: [],
      uploadIndex: -1,
      loadingFile: false,
      viewImg: false,
      editedIndex: -1,
      editedIndexTip: -1,
      items: [],
      error: false,
      datemenu: false,
      dialog: false,
      dialogFilter: false,
      dialogXML: false,
      dialogItem: false,
      menu: false,
      menu2: false,
      valid: true,
      loading: false,
      loadItem: false,
      loadTable: true,
      downloadLoading: false,
      addExpenseDialog: false,
      dataURL: null,
      categories: [],
      satFormaPago: [],
      satMetodoPago: [],
      satMoneda: [],
      satPais: [],
      editedItem: {
        gst_categories: {
          name: ''
        },
        receipt_type: {
          name: ''
        }
      },
      editedItemExpense: {
        fileId: null,
        start_date: '',
        end_date: '',
        emisor: '',
        gst_expenses_id: null,
        gst_receipt_types_id: 2,
        date: null,
        gst_categories_id: null,
        categoryName: '',
        is_refund: false,
        description: '',
        exchange: 1,
        subtotal: '',
        total: '',
        country: {
          id: 151,
          descripcion: ''
        },
        currency: {
          id: 100,
          descripcion: ''
        },
        folio: '',
        comment: '',
        discount: null,
        sat_forma_pago: {
          descripcion: ''
        },
        sat_metodo_pago: {
          descripcion: ''
        },
        hasTip: false
      },
      editedItemTip: {
        id: null,
        amount: null,
        fileId: null,
        created_at: ''
      },
      defaultItemTip: {
        id: null,
        amount: null,
        fileId: null,
        created_at: ''
      },
      defaultItem: {
        emisor: '',
        gst_expenses_id: null,
        gst_receipt_types_id: 2,
        date: null,
        gst_categories_id: null,
        is_refund: false,
        description: '',
        exchange: 1,
        subtotal: '',
        total: '',
        country: {
          id: 151,
          descripcion: ''
        },
        currency: {
          id: 100,
          descripcion: ''
        },
        sat_forma_pago: {
          descripcion: ''
        },
        sat_metodo_pago: {
          descripcion: ''
        },
        folio: '',
        comment: '',
        fileId: null,
        discount: null,
        hasTip: false,
        amountTip: null,
        fileIdTip: null
      },
      cfdiHtml: null,
      errors: {},
      status: 'EXCLUDED',
      search: '',
      conciliations: [],
      pagination: {
        sortBy: 'id',
        descending: true,
        page: 1,
        rowsPerPage: 15,
        totalItems: 0
      },
      // no fiscal
      dropzoneOptions: {
        url: process.env.HOST + 'api/File',
        dictDefaultMessage: this.$t('dropzone.default', { size: '5', unit: 'MB' }),
        dictResponseError: this.$t('dropzone.responseError'),
        dictFileTooBig: this.$t('dropzone.fileTooBig'),
        dictInvalidFileType: this.$t('dropzone.invalidFileType'),
        dictRemoveFile: this.$t('dropzone.removeFile'),
        dictRemoveFileConfirmation: this.$t('dropzone.removeFileConfirmation'),
        dictMaxFilesExceeded: this.$t('dropzone.maxFilesExceeded'),
        addRemoveLinks: true,
        thumbnailWidth: 150,
        maxFilesize: 5,
        resizeWidth: 1080,
        resizeHeight: 1080,
        resizeMethod: 'contain',
        resizeQuality: 0.8,
        paramName: 'path',
        acceptedFiles: '.jpeg,.jpg,.png,.pdf',
        maxFiles: 1,
        headers: { 'Authorization': 'Bearer ' + this.$store.state.userState.access_token },
        params: {
          'user_id': this.$store.state.userLogged.id,
          'dirname': 'IMG_EXPENSES'
        }
        // init: function () {
        //   const self = this
        //   this.on('success', function (file) {
        //     let parseFile = JSON.parse(file.xhr.response)
        //     self.editedItemExpense.fileId = parseFile.data.id
        //     // this.editedItemExpense.fileId = parseFile.data.id
        //   })
        // }
      },
      // fiscal
      dropzoneOptionsXML: {
        url: process.env.HOST + 'api/File',
        dictDefaultMessage: this.$t('dropzone.textFileXml', { size: '500', unit: 'KB' }),
        dictFileTooBig: this.$t('dropzone.fileTooBig'),
        dictInvalidFileType: this.$t('dropzone.invalidFileType'),
        dictRemoveFile: this.$t('dropzone.removeFile'),
        dictRemoveFileConfirmation: this.$t('dropzone.removeFileConfirmation'),
        dictMaxFilesExceeded: this.$t('dropzone.maxFilesExceeded'),
        addRemoveLinks: true,
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        paramName: 'path',
        dictResponseError: this.errorFileUpload,
        acceptedFiles: '.xml',
        // maxFiles: 1,
        headers: { 'Authorization': 'Bearer ' + this.$store.state.userState.access_token },
        params: {
          'user_id': this.$store.state.userLogged.id,
          'files_type_id': 7,
          'dirname': 'XML_EXPENSES'
        }
      },
      selectXml: null,
      readXml: null,
      fileName: '',
      fileUrl: '',
      file: ''
    }
  },
  created () {
    this.getLogged()
  },
  computed: {
    rules () {
      return this.$validationRules()
    },
    heading () {
      return this.$t('conciliation.titleExcluded')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'fa fa-handshake fa-fw icon-color'
    },
    errorFileUpload () {
      return this.errorMessage
    },
    dataArrayFilter () {
      return this.$searchCountry()
    },
    submitXMLButton () {
      return this.uploadIndex + 1 < this.uploadedXML.length ? this.$t('general.next') : this.$t('general.submit')
    },
    setMXN () {
      let item = this.editedItem
      if (item.currency !== undefined && item.currency.id === 100) {
        item.exchange = 1
        return true
      } else {
        return false
      }
    },
    formTitle () {
      if (this.editedIndex > -1) {
        return this.$t('expenseItems.name')
      } else {
        return this.$t('general.receipt')
      }
    },
    sumaTotal () {
      let total = 0
      if (this.conciliations.length > 0) {
        this.conciliations.map(item => {
          let amount = this.excludedType === 'AMEX' ? item.amount : item.total_mxn
          amount = amount ? parseFloat(amount) : 0
          total = total + amount
        })
      }
      return total
    },
    headers () {
      let list = []
      if (this.excludedType === 'AMEX') {
        list = [
          {
            text: this.$t('conciliation.amexExpenseNo'),
            align: 'center',
            value: 'id',
            sortable: true
          },
          {
            text: this.$t('general.name'),
            align: 'center',
            value: 'user.name',
            sortable: true
          },
          {
            text: this.$t('general.transactionDate'),
            align: 'center',
            value: 'consiliate_date',
            sortable: true
          },
          {
            text: this.$t('conciliation.accountNo'),
            align: 'center',
            value: 'user.card_number',
            sortable: true
          },
          {
            text: this.$t('conciliation.transactionNo'),
            align: 'center',
            value: 'transaction_number',
            sortable: true
          },
          {
            text: this.$t('pettyCash.vendor'),
            align: 'center',
            value: 'supplier_name',
            sortable: true
          },
          {
            text: this.$t('conciliation.description'),
            align: 'center',
            value: 'description',
            sortable: true
          },
          {
            text: this.$t('conciliation.amount'),
            align: 'center',
            value: 'amount',
            sortable: true
          },
          {
            text: this.$t('general.actions'),
            align: 'center',
            sortable: false
          }
        ]
      } else if (this.excludedType === 'BLUESPEND') {
        list = [
          {
            text: this.$t('conciliation.BluExpenseNo'),
            align: 'center',
            value: 'id',
            sortable: true
          },
          {
            text: this.$t('general.name'),
            align: 'center',
            value: 'gst_expenses.user.name',
            sortable: true
          },
          {
            text: this.$t('conciliation.expenseDate'),
            align: 'center',
            value: 'date',
            sortable: true
          },
          {
            text: this.$t('pettyCash.vendor'),
            align: 'center',
            value: 'issuer_name',
            sortable: true
          },
          {
            text: this.$t('conciliation.description'),
            align: 'center',
            value: 'description',
            sortable: true
          },
          {
            text: this.$t('general.folio'),
            align: 'center',
            value: 'folio',
            sortable: true
          },
          {
            text: this.$t('conciliation.amount'),
            align: 'center',
            value: 'amount',
            sortable: true
          },
          {
            text: '',
            align: 'center',
            value: 'amount',
            sortable: false
          }
        ]
      }
      return list
    },
    headersByUser () {
      let header = this.headers
      if (this.excludedType !== 'AMEX') {
        header = this.headers.filter(x => x.text !== this.$t('general.actions'))
      }
      return header
    }
  },
  watch: {
    editedItemExpense (value) {
      if (value.gst_receipt_types_id && value.gst_receipt_types_id === 2) {
        this.showExpenseItemFile()
      } else if (value.gst_receipt_types_id && value.gst_receipt_types_id === 1) {
        this.showXMLFile()
      }
    },
    switchAllEmployees (value) {
      if (value) {
        this.selectedEmployee = null
      }
    },
    '$route.params.id': function (id) {
      this.get()
    },
    '$store.state.userLogged' () {
      this.getLogged()
      this.dropzoneOptions.params.user_id = this.$store.state.userLogged.id
      this.dropzoneOptionsXML.params.user_id = this.$store.state.userLogged.id
    },
    removeDialog (val) {
      val || this.closeRemove()
    },
    dialogXML () {
      if (this.dialogXML === true) {
        this.selectXml = true
      }
    },
    search (val) {
      this.querySelection(val)
      this.dataArrayFilter.search(this.editedItemExpense.country.id, val)
    }
  },
  methods: {
    refresh () {
      this.get()
    },
    resetConfirm (item) {
      this.expenseAmex.id = item.id
      this.expenseAmex.transaction_number = item.transaction_number
      this.expenseAmex.description = item.description
      this.resetDialog = true
    },
    resetToReconcile () {
      this.$emit('resetToReconcile', {
        expense_amex_id: this.expenseAmex.id,
        context: this
      })
    },
    calculateTotals () {
      this.loading = true
      this.$emit('calculateTotals', {
        user_id: this.selectedEmployee,
        startDate: this.startDate,
        endDate: this.endDate,
        context: this
      })
    },
    filterAmounts () {
      this.allAmount = this.totalAmounts.all
      this.consiliateAmount = this.totalAmounts.consiliate
      this.excludedAmount = this.totalAmounts.excluded
      this.missingAmount = this.totalAmounts.null
    },
    getLogged () {
      let current = new Date()
      let before = new Date().setDate(current.getDate() - 30)
      let dateStart = new Date(before).toISOString().substr(0, 10)
      this.startDate = dateStart
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
        this.get()
        this.getEmployees()
        this.calculateTotals()
      }
    },
    selectedEmployeeChange () {
      this.get()
      this.calculateTotals()
    },
    dateFormat (date) {
      let formatted = date.replace(/-/g, '/')
      return formatted
    },
    querySelection (val) {
      this.items = this.dataArrayFilter.querySelection(this.satPais, val)
    },
    expenseItemsFilter () {
      this.sumaSubtotal = 0
      this.sumaDescuento = 0
      this.sumaTotal = 0
      this.filteredExpenseItems.forEach((value, index) => {
        this.sumaSubtotal += value.subtotal != null ? parseFloat(value.subtotal) : parseFloat(0)
        this.sumaDescuento += value.discount != null ? parseFloat(value.discount) : parseFloat(0)
        this.sumaTotal += value.total != null ? parseFloat(value.total * value.exchange) : parseFloat(0)
      })
    },
    checkExpensesMessage () {
      var isNull = false
      this.filteredExpenseItems.forEach(item => {
        if (item.subtotal == null) {
          isNull = true
        }
      })
      if (isNull) {
        return `<h5 class="mt-3"><i aria-hidden="true" class="v-icon material-icons theme--light mr-2">warning</i>${this.$t('expenseItems.downloadProcess')}</h5>`
      } else {
        return ``
      }
    },
    addFiscal (item) {
      this.expenses_amex_id = item.id
      this.dialogXML = true
    },
    addNoFiscal (item) {
      this.expenses_amex_id = item.id
      this.dialog = true
    },
    countryFilter (item, queryText, itemText) {
      const description = item.descripcion.toLowerCase()
      const abbr = item.c_Pais.toLowerCase()
      const searchText = queryText.toLowerCase()
      return description.indexOf(searchText) > -1 || abbr.indexOf(searchText) > -1
    },
    currencyFilter (item, queryText, itemText) {
      const description = item.descripcion.toLowerCase()
      const abbr = item.c_Moneda.toLowerCase()
      const searchText = queryText.toLowerCase()
      return description.indexOf(searchText) > -1 || abbr.indexOf(searchText) > -1
    },
    closeDialog () {
      this.dialog = false
      this.dialogFilter = false
      this.editedItemExpense = Object.assign({}, JSON.parse(JSON.stringify(this.defaultItem)))
      this.editedIndex = -1
      this.expenses_amex_id = null
      this.reset()
      this.closeCfdiDialog()
    },
    closeCfdiDialog () {
      this.cfdiDialog = false
      this.editedItemExpense = Object.assign({}, JSON.parse(JSON.stringify(this.defaultItem)))
      this.expenses_amex_id = null
    },
    closeDialogTip () {
      this.dialogTip = false
      this.editedItemTip = Object.assign({}, JSON.parse(JSON.stringify(this.defaultItemTip)))
      this.editedIndexTip = -1
      this.reset()
    },
    // Reset the current form
    reset () {
      this.$refs.form.resetValidation()
      if (this.$refs.dropzone !== undefined) {
        this.$refs.dropzone.removeAllFiles()
      }
      this.viewImg = false
      this.dataURL = null
    },
    // If the form is valid, post it
    submit () {
      if (this.$refs.form.validate()) {
        this.loading = true
        if (this.editedItemExpense.id !== undefined) {
          this.put()
        } else {
          if (this.editedItemExpense.fileId !== null && this.editedItemExpense.fileId !== undefined) {
            this.post()
          } else {
            this.loading = false
            this.showNotification(this.$t('expenseItems.noFileUploaded'), 'error', -1)
          }
        }
      }
    },
    post () {
      this.$store.dispatch('expensesItems/postFromExcluded', {
        event: {
          item: this.editedItemExpense,
          context: this,
          expense_id: null,
          expenses_amex_id: this.expenses_amex_id,
          has_next: this.uploadIndex + 1 < this.uploadedXML.length
        }
      })
    },
    postTip () {
      if (this.editedItemTip.amount !== null && this.editedItemTip.fileId !== null) {
        this.$emit('postTip', {
          item: this.editedItemTip,
          context: this
        })
      }
    },
    postTipExpense (expenseId) {
      if (this.editedItemTip.amount !== null && this.editedItemTip.fileId !== null) {
        this.editedItemTip.id = expenseId
        this.$emit('postTip', {
          item: this.editedItemTip,
          context: this
        })
      }
    },
    put () {
      this.$emit('put', {
        item: this.editedItemExpense,
        index: this.editedIndex,
        context: this
      })
    },
    submitTip () {
      if (this.$refs.tipForm.validate()) {
        this.loading = true
        if (this.editedItemTip.fileId !== null && this.editedItemTip.fileId !== undefined) {
          this.postTip()
        } else {
          this.loading = false
          this.showNotification(this.$t('expenseItems.noFileUploaded'), 'error', -1)
        }
      }
    },
    // Close modal dialog
    closeDialogXML () {
      this.dialogXML = false
      this.loadingFile = false
      this.editedItemExpense = Object.assign({}, JSON.parse(JSON.stringify(this.defaultItem)))
      this.editedIndex = -1
      this.uploadedXML = []
      this.uploadIndex = -1
      this.resetXML()
    },
    // Reset the current form
    resetXML () {
      this.selectXml = true
      this.readXml = null
      this.errors = {}
      this.uploadedXML = []
      this.uploadIndex = -1
      this.loadingFile = false
      this.$refs.formXML.resetValidation()
      if (this.$refs.dropzoneXML !== undefined) {
        this.$refs.dropzoneXML.removeAllFiles()
      }
    },
    // If the form is valid, post it
    submitXML () {
      if (this.$refs.formXML.validate()) {
        this.loading = true
        this.loadingFile = false
        this.post()
      }
    },
    xmlUpload (file, response) {
      this.loadingFile = true
      this.uploadedXML.push(response.data)
    },
    xmlQueueComplete () {
      this.selectXml = false
      this.uploadIndex = 0
      this.parseXml(this.uploadedXML[0].id)
    },
    fileAdded (file) {
      this.dropzoneOptions.params.user_id = this.$store.state.userLogged.id
      let fileType = file.type
      if (fileType === 'image/jpeg') {
        this.dropzoneOptions.params.files_type_id = 5
      } else if (fileType === 'image/png') {
        this.dropzoneOptions.params.files_type_id = 6
      } else if (fileType === 'application/pdf') {
        this.dropzoneOptions.params.files_type_id = 3
      }
    },
    fileUpload (file, response) {
      this.editedItemExpense.fileId = response.data.id
    },
    fileUploadTip (file, response) {
      this.editedItemTip.fileId = response.data.id
    },
    fileUploadError (file, message, xh) {
      this.showNotification(message, 'error', -1)
      this.errorMessage = message.errors.path[0]
    },
    fileAddedXml (file) {
      this.dropzoneOptionsXML.params.user_id = this.$store.state.userLogged.id
    },
    parseXml (id) {
      this.$store.dispatch('expensesItems/readXmlQueueItemFromExcluded', {
        event: {
          file_id: id,
          context: this
        }
      })
    },
    showNextUpload () {
      this.readXml = null
      this.uploadIndex += 1
      if (this.uploadIndex < this.uploadedXML.length) {
        this.parseXml(this.uploadedXML[this.uploadIndex].id)
      } else {
        this.closeDialogXML()
        this.refresh()
      }
    },
    getSatFormaPago (value) {
      return this.satFormaPago.find(element => element.c_FormaPago === value)
    },
    getSatMetodoPago (value) {
      return this.satMetodoPago.find(element => element.c_MetodoPago === value)
    },
    getCurrency (value) {
      return this.satMoneda.find(element => element.c_Moneda === value)
    },
    getCountry (value) {
      return this.satPais.find(element => element.c_Pais === value)
    },
    // Click on file input
    pickFile () {
      this.$refs.file.click()
    },
    // Process the selected file on file input
    onFilePicked (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        this.fileName = files[0].name
        if (this.fileName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.fileUrl = fr.result
          this.file = files[0] // this is an image file that can be sent to server
        })
      } else {
        this.fileName = ''
        this.file = ''
        this.fileUrl = ''
      }
    },
    amountMXN (amount, exchange) {
      if (amount === '') {
        amount = 0
      }
      return (amount * exchange).toFixed(2)
    },
    getTotal (type) {
      switch (type) {
        default:
        case 1:
          this.editedItemExpense.total = this.editedItemExpense.subtotal
          break
        case 2:
          this.editedItemExpense.subtotal = this.editedItemExpense.total
          break
      }
    },
    changeSort (header) {
      if (header.sortable) {
        if (this.pagination.sortBy === header.value) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.descending = false
        }
        this.pagination.sortBy = header.value
      } else {
        this.pagination.sortBy = ''
      }
    },
    close () {
      this.dialog = false
      this.resetDialog = false
      this.dialogFilter = false
      this.dialogItem = false
      this.addExpenseDialog = false
      this.loadTable = false
      this.expenseAmex = Object.assign({}, this.defaultExpenseAmex)
    },
    send () {
      this.get()
      this.calculateTotals()
      this.dialogFilter = false
    },
    getEmployees () {
      this.companyId = this.userLogged.company[0].id
      this.$store.dispatch('expenseDetailEmployee/getCompanyEmployee', {
        event: {
          context: this,
          item: {
            companyId: this.companyId
          }
        }
      })
    },
    get () {
      this.loadTable = true
      if (this.userLogged.roles && this.userLogged.roles[0].name === 'ADMIN') {
        this.getEmployees()
        if (this.excludedType === 'AMEX') {
          this.$emit('get', {
            context: this,
            userId: this.selectedEmployee,
            start_date: this.startDate,
            end_date: this.endDate
          })
        } else if (this.excludedType === 'BLUESPEND') {
          this.$emit('getExcludedBLUESPEND', {
            item: {
              company_id: this.userLogged.company[0].id,
              start_date: this.startDate,
              end_date: this.endDate,
              userId: this.selectedEmployee,
              type: 'json'
            },
            context: this
          })
        }
      } else if (this.userLogged.roles && this.userLogged.roles[0].name === 'EMPLOYEE') {
        if (this.excludedType === 'AMEX') {
          this.$emit('get', {
            context: this,
            userId: this.userLogged.id
          })
        } else if (this.excludedType === 'BLUESPEND') {
          this.$emit('getExcludedBLUESPEND', {
            item: {
              company_id: this.userLogged.company[0].id,
              start_date: this.startDate,
              end_date: this.endDate,
              userId: this.userLogged.id,
              type: 'json'
            },
            context: this
          })
        }
      }
      this.$store.dispatch('getSatFormaPago', { event: { context: this } })
      this.$store.dispatch('getSatMetodoPago', { event: { context: this } })
      this.$store.dispatch('getSatMoneda', { event: { context: this } })
      this.$store.dispatch('getSatPais', { event: { context: this } })
      this.$store.dispatch('expensesItems/getCategories', { event: { context: this } })
    },
    applyFilter () {
      this.get()
      this.dialogFilter = false
    },
    viewExpenses (item) {
      this.editedItemExpenses = item
      this.loadItem = true
      this.dialogItem = true
      this.$store.dispatch('expensesItems/getItem', {
        event: {
          id: item.id,
          context: this
        }
      })
    },
    downloadXls () {
      if (this.userLogged.roles && this.userLogged.roles[0].name === 'ADMIN') {
        if (this.excludedType === 'AMEX') {
          this.$emit('get', {
            type: 'download',
            startDate: this.startDate,
            endDate: this.endDate,
            context: this,
            userId: this.selectedEmployee
          })
        } else if (this.excludedType === 'BLUESPEND') {
          this.$emit('getExcludedBLUESPEND', {
            item: {
              company_id: this.userLogged.company[0].id,
              startDate: this.startDate,
              endDate: this.endDate,
              userId: this.selectedEmployee,
              type: 'download'
            },
            context: this
          })
        }
      } else if (this.userLogged.roles && this.userLogged.roles[0].name === 'EMPLOYEE') {
        if (this.excludedType === 'AMEX') {
          this.$emit('get', {
            type: 'download',
            startDate: this.startDate,
            endDate: this.endDate,
            userId: this.userLogged.id,
            context: this
          })
        } else if (this.excludedType === 'BLUESPEND') {
          this.$emit('getExcludedBLUESPEND', {
            item: {
              company_id: this.userLogged.company[0].id,
              start_date: this.startDate,
              end_date: this.endDate,
              userId: this.userLogged.id,
              type: 'download'
            },
            context: this
          })
        }
      }
    },
    showExpenseItemFile () {
      if (this.editedItemExpense.gst_expenses_items_files !== undefined && this.editedItemExpense.gst_expenses_items_files !== null) {
        if (this.editedItemExpense.gst_expenses_items_files.length > 0) {
          this.$store.dispatch('getFile', {
            event: {
              context: this,
              fileId: this.editedItemExpense.gst_expenses_items_files[0].files_id
            }
          })
        }
      }
    },
    showXMLFile () {
      if (this.editedItemExpense.gst_expenses_items_files.length > 0) {
        this.$store.dispatch('readXmlToHtml', {
          event: {
            id: this.editedItemExpense.gst_expenses_items_files[0].files_id,
            context: this
          }
        })
      }
    },
    isPDF (data) {
      if (data !== null) {
        let type = data.slice(data.indexOf('/') + 1, data.indexOf(';'))
        if (type === 'pdf') {
          return true
        } else {
          return false
        }
      }
    },
    openPDF () {
      var tab = window.open()
      tab.document.write('<body style="margin: 0;"> <iframe src="' + this.dataURL + '" frameborder="0" style="margin: 0; padding: 0; border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;"</iframe></body>')
    },
    getFile (fileId) {
      this.$store.dispatch('getFile', {
        event: {
          context: this,
          fileId: fileId
        }
      })
    }
  }
}
</script>

<style scoped>
.yellow-block {
  background-color: #F8E9A1 !important;
}
.blue-block{
  background-color: #D8E8F8 !important;
}
.green-block{
  background-color: #B2E8D1 !important;
}
.red-block{
  background-color: #F4C7C3 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/excludedExpenses.component.vue